import React from 'react';
import { ImageMarkup, LoadingSpinner } from 'yankees-react-utils';
import { BarrelBox as BarrelBoxApi, useOktaQuery } from '../../../../data';
import StrikeZoneRhh from '../../../../images/strike-zone-rhh.png';
import StrikeZoneLhh from '../../../../images/strike-zone-lhh.png';
import BboxOvhRhh from '../../../../images/batters-box-overhead-rhh.png';
import BboxOvhLhh from '../../../../images/batters-box-overhead-lhh.png';

const DEFAULT_HEIGHT = 315;
const DEFAULT_WIDTH = 272;

const BarrelBox = ({ pitcherId, isLhh, order, levelId }) => {
    const { data: barrelBox, isLoading } = useOktaQuery(
        ['barrelBox', pitcherId, isLhh, order, levelId],
        (t) => BarrelBoxApi.query(t, { pitcherId, isLhh, order, levelId }),
    );

    if (isLoading) return <div className="py-5 text-center"><LoadingSpinner /></div>;

    if (!barrelBox?.length) {
        return (
            <div>
                <ImageMarkup
                    height={DEFAULT_HEIGHT}
                    width={DEFAULT_WIDTH}
                    backgroundImage={isLhh ? StrikeZoneLhh : StrikeZoneRhh}
                    initialElements={[]}
                />
            </div>
        );
    }

    const firstBarrelBox = barrelBox[0];
    let bImg = firstBarrelBox.IsLhh ? StrikeZoneLhh : StrikeZoneRhh;
    if (firstBarrelBox.IsOverhead) bImg = firstBarrelBox.IsLhh ? BboxOvhLhh : BboxOvhRhh;

    return (
        <div key={`${pitcherId}-${isLhh}-${order}-${levelId}-${firstBarrelBox.ImageMarkupId}`}>
            <ImageMarkup
                height={firstBarrelBox.Height ?? DEFAULT_HEIGHT}
                width={firstBarrelBox.Width ?? DEFAULT_WIDTH}
                initialElements={JSON.parse(firstBarrelBox.Markup ?? '[]')}
                backgroundImage={bImg}
            />
        </div>
    );
};

export default BarrelBox;
